import {
  MutationBitbucketCloudIntegrationCreateArgs,
  MutationBitbucketCloudIntegrationUpdateArgs,
  VcsCheck,
} from "types/generated";
import { ROOT_SPACE_ID } from "constants/space";

import { ManageBitbucketCloudFormFields } from "./types";
import { VCS_INTEGRATION_TYPES } from "../../constants";
import { BitbucketCloudIntegrationData } from "./Edit/gql";

export const getFormDefaultValues = (
  integration?: BitbucketCloudIntegrationData
): ManageBitbucketCloudFormFields => {
  const useGitCheckoutValue = integration ? integration?.useGitCheckout : true;
  return {
    name: integration?.name || "",
    space: integration?.space?.id || "",
    username: integration?.username || "",
    appPassword: "",
    integrationType: integration?.isDefault
      ? VCS_INTEGRATION_TYPES.DEFAULT
      : VCS_INTEGRATION_TYPES.MULTIPLE,
    labels: integration?.labels?.map((label) => ({ value: label })) || [],
    description: integration?.description || "",
    vcsChecks: integration?.vcsChecks || VcsCheck.Individual,
    useGitCheckout: useGitCheckoutValue,
  };
};

export const mapCreateIntegrationInputValues = (
  values: ManageBitbucketCloudFormFields
): MutationBitbucketCloudIntegrationCreateArgs => {
  const isDefault = values.integrationType === VCS_INTEGRATION_TYPES.DEFAULT;

  return {
    appPassword: values.appPassword.trim(),
    customInput: {
      isDefault,
      name: values.name.trim(),
      labels: values.labels.map((label) => label.value) || [],
      spaceID: isDefault ? ROOT_SPACE_ID : values.space,
      description: values.description?.trim() || null,
      vcsChecks: values.vcsChecks,
      useGitCheckout: values.useGitCheckout,
    },
    username: values.username.trim(),
  };
};

export const mapUpdateIntegrationInputValues = (
  values: ManageBitbucketCloudFormFields,
  integrationId: string
): MutationBitbucketCloudIntegrationUpdateArgs => ({
  appPassword: values.appPassword?.trim() || null,
  customInput: {
    id: integrationId,
    labels: values.labels.map((label) => label.value) || [],
    space: values.space,
    description: values.description?.trim() || null,
    vcsChecks: values.vcsChecks,
    useGitCheckout: values.useGitCheckout,
  },
  username: values.username.trim(),
});
